var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.36362V10.8491H13.8436C13.6309 11.97 12.9927 12.9191 12.0354 13.5573L14.9563 15.8237C16.6581 14.2528 17.64 11.9455 17.64 9.20462C17.64 8.56645 17.5827 7.95275 17.4763 7.36371L9 7.36362Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95645 10.713L3.29768 11.2173L0.96582 13.0336C2.44673 15.9709 5.48196 18 9.00011 18C11.43 18 13.4673 17.1982 14.9564 15.8237L12.0355 13.5573C11.2337 14.0973 10.211 14.4246 9.00011 14.4246C6.66012 14.4246 4.672 12.8455 3.96013 10.7182L3.95645 10.713Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.965384 4.96637C0.351781 6.17723 0 7.54361 0 8.99995C0 10.4563 0.351781 11.8227 0.965384 13.0335C0.965384 13.0417 3.95998 10.7099 3.95998 10.7099C3.77998 10.1699 3.67359 9.59721 3.67359 8.99986C3.67359 8.40251 3.77998 7.82981 3.95998 7.28982L0.965384 4.96637Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00029 3.58363C10.3258 3.58363 11.5039 4.0418 12.4448 4.92545L15.0221 2.34821C13.4594 0.891874 11.4303 0 9.00029 0C5.48214 0 2.44673 2.02091 0.96582 4.96637L3.96033 7.29001C4.6721 5.16271 6.66031 3.58363 9.00029 3.58363Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2cf64123573ed6f61b0e8835ea8d9f4e.svg";
export { ForwardRef as ReactComponent };